import de from './de-DE.json';
const languages = {
    'de-DE': {
        translation: de,
    },
};
export default languages;
